// Compact EN / FR / ES segmented switch. Sits next to the mic in any exchange so
// the user can pick the language the twin answers in.

import type { Language } from '../lib/prefs.js';

const LANGS: Language[] = ['fr', 'en', 'es'];

export function LanguageSwitch({ value, onChange, size = 'md' }: {
  value: Language;
  onChange: (l: Language) => void;
  size?: 'sm' | 'md';
}) {
  const pad = size === 'sm' ? 'px-1.5 py-0.5 text-[8.5px]' : 'px-2 py-1 text-[9.5px]';
  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 rounded-full border border-ink/12 bg-white/[0.02]">
      {LANGS.map((l) => (
        <button key={l} onClick={() => onChange(l)} title={`Répondre en ${l.toUpperCase()}`}
          className={`${pad} rounded-full transition-colors ${ value === l ? 'bg-ink text-void' : 'text-ink/45 hover:text-ink/80' }`}>
          {l}
        </button>
      ))}
    </div>
  );
}
